import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ProblemSolution from '../components/ProblemSolution';
import Benefits from '../components/Benefits';
import HowItWorks from '../components/HowItWorks';
import WhatsIncluded from '../components/WhatsIncluded';
import WhoItsFor from '../components/WhoItsFor';
import SocialProof from '../components/SocialProof';
import BuiltBy from '../components/BuiltBy';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const Home = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'instant', block: 'start' });
      };
      const t = setTimeout(scroll, 300);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="brand-theme min-h-screen overflow-x-hidden relative selection:bg-lime selection:text-ink">
      <div className="absolute inset-0 dot-pattern pointer-events-none" />
      <div className="relative z-10">
        <Header />
        <Hero />
        <ProblemSolution />
        <SocialProof />
        <Benefits />
        <HowItWorks />
        <WhatsIncluded />
        <WhoItsFor />
        <BuiltBy />
        <FAQ />
        <CTA />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
